import React from 'react';
import { motion } from 'framer-motion';
import { BibleCover } from './BibleCover';
import { bibleProducts } from '../data/bibleProducts';
export function BibleProducts() {
  return <div className="mt-9 grid grid-cols-1 gap-3 min-[381px]:grid-cols-2 md:grid-cols-3 md:gap-[22px]" style={{
    perspective: '1400px'
  }} data-id="element-20" data-mp="2x8v2te7xdjb">
      {bibleProducts.map((product, index) => <motion.article key={product.id} initial={{
      opacity: 0,
      y: 34,
      rotateX: 8
    }} whileInView={{
      opacity: 1,
      y: 0,
      rotateX: 0
    }} viewport={{
      once: true,
      amount: 0.25
    }} transition={{
      duration: 0.6,
      delay: index % 3 * 0.08,
      ease: [0.22, 1, 0.36, 1]
    }} className="bible-tilt rounded-xl border border-[#2c2a30] bg-[#141419] p-[9px] md:p-[14px]" data-id="element-21" data-mp="36dz2ncpg7yn4" data-mpi={index}>
          <BibleCover asset={product.asset} lines={product.coverLines} note={product.coverNote} className="mb-5" data-id="element-22" data-mp="voae55l17t84" />
          <div className="mx-0.5 md:mx-2" data-id="element-23" data-mp="zyvkl8ivl4f6">
            <span className="mb-3 block text-[10px] tracking-[0.15em] text-[#e9c769]" data-id="element-24" data-mp="14yro76nnutu7">
              {product.tag}
            </span>
            <h3 className="bible-serif-tight text-[17px] leading-[1.35] md:text-[20px]" data-id="element-25" data-mp="19xl4f6uc0yy2">
              {product.title}
            </h3>
            <p className="mt-2 text-[13px] leading-[1.6] text-[#beb9b0] md:text-[14px]" data-id="element-26" data-mp="1dyn41os5vd0k">
              {product.description}
            </p>
          </div>
        </motion.article>)}
    </div>;
}